import { EmbeddedUser } from './types';

/** Display title: full name when both parts are present, otherwise the email. */
export function getUserTitle(user: Pick<EmbeddedUser, 'first_name' | 'last_name' | 'email'>): string {
  return user.first_name && user.last_name ? `${user.first_name} ${user.last_name}` : user.email;
}
